(function userModuleDefinition() {
    'use strict';

    angular.module('User', ['ui.router', 'ui.bootstrap.carousel', 'Config', 'Entities', 'ErrorsExtend', 'dndLists', 'UnitOrgComboControl', 'UnitOrgControl', 'AuthExtend', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function userConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('user-add', {
                    url: "/User/Add",
                    templateUrl: config.resourceUrl('/views/user/add-modify.html'),
                    controller: 'UserAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER WRITE')
                });

                $stateProvider.state('user-add-new', {
                    url: "/User/AddNew",
                    templateUrl: config.resourceUrl('/views/user/add-modify.html'),
                    controller: 'UserAddNewController',
                    authorize: false,
                    params: { userName: null, password: null }
                });

                $stateProvider.state('user-modify', {
                    url: "/User/Modify/{id}",
                    templateUrl: config.resourceUrl('/views/user/add-modify.html'),
                    controller: 'UserModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER WRITE')
                });

                $stateProvider.state('user-find', {
                    url: '/User/List',
                    templateUrl: config.resourceUrl('/views/User/list.html'),
                    controller: 'UserFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER READ').or('USER WRITE')
                });

                $stateProvider.state('user-detail', {
                    url: '/User/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/user/detail.html'),
                    controller: 'UserDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER READ').or('USER WRITE')
                });

                $stateProvider.state('user-roles', {
                    url: '/User/AssociateRoles/{id}',
                    templateUrl: config.resourceUrl('/views/user/associate-roles.html'),
                    controller: 'UserAssociateRolesController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER WRITE')
                });

                $stateProvider.state('user-add-certificate', {
                    url: '/User/AddCertificate',
                    params: { id: undefined, ouId: undefined, userName: undefined },
                    templateUrl: config.resourceUrl('/views/user/add-certificate.html'),
                    controller: 'UserAddCertificateController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE START')
                });

                $stateProvider.state('user-arandanos-find', {
                    url: '/User/ListArandanosOption',
                    templateUrl: config.resourceUrl('/views/user/list-arandanos.html'),
                    controller: 'UserArandanosFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ENABLE ARANDANOS UI')
                });
            }
        ]);
})();